import { createRouter, createWebHistory } from 'vue-router'
import TermsOfService from '../components/TermsOfService.vue'
import LandingPage from '@/components/LandingPage.vue'


// 2. Define some routes
// Each route should map to a component.
// We'll talk about nested routes later.
const routes = [
  { path: '/', component: LandingPage },
  { path: '/terms-of-service', component: TermsOfService },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior (to, from, savedPosition) {
      return { top: 0 }
    }
  })
  
  export default router
  